import { render, staticRenderFns } from "./Forgot-Password-Component.vue?vue&type=template&id=29db4262&scoped=true&"
import script from "./Forgot-Password-Component.vue?vue&type=script&lang=js&"
export * from "./Forgot-Password-Component.vue?vue&type=script&lang=js&"
import style0 from "./Forgot-Password-Component.vue?vue&type=style&index=0&id=29db4262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29db4262",
  null
  
)

export default component.exports